import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import DivideLine from '../decoration/divideLine';

// import './singleCategory/singleCategory.css';

class SingleCategoryItem extends Component{
  getImageId = (url) =>{
    return url.substring(url.lastIndexOf('/')+1);
  }

  getResizeImage = (url, w, h) =>{
    const host = '//d3r3r4tgtn0hwd.cloudfront.net/'
    //return `${host}${w}x${h}/${this.getImageId(url)}`; disable size because resize function not working now
    return `${host}${this.getImageId(url)}`;
  }
  render() {
    let info = this.props.info;
    let dynamicClass = this.props.dynamicClass;
    let catename = this.props.catename;
    const {flowerPrice} = info;
    let freshFlowerOption = null; // seems fine to render a null value;
    if (flowerPrice!==-1){
      freshFlowerOption =
          <div className="SingleCategoryItemRow">
              <span> (Fresh Flower: $ {info.flowerPrice}) </span>
          </div>;
    }
    console.log("REACT JS")
    console.log("catename "+catename)
    console.log(info);

    return(
      <div className={`SingleCategoryItem ${dynamicClass}`}>
        <Link className="SingleCategoryItemLink" to={`/category/${catename}/${info.id}`} >
          <div className="singleCatagoryItemImgWrapper">
            <img src={this.getResizeImage(info.imageURL, '1200', '1800')} alt={info.name}/>
          </div>
          <div className="singleCategoryCaption">
            <div className="SingleCategoryItemRow">
              <span className="SingleCategoryItemName">{info.name.split(' ')[0]} </span>
              {(info.height > 0 && info.width > 0)? <span className="SingleCategoryItemSize"> Size: H:{info.height} W:{info.width} </span>: <span></span>}
              
              {info.wholePrice > 1? <span className="SingleCategoryItemWholePrice"> HK${info.wholePrice} </span>:  <span className="SingleCategoryItemWholePrice">  </span>}
            </div>
          </div>
          </Link>
      </div>
    );
  }
}

export default SingleCategoryItem;



// WEBPACK FOOTER //
// ./src/components/singleCategory/singleCategoryItem.js